import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';

import WorkflowService from '../../../services/Workflow.service';
import useNotify from '../../../context/Notification/useNotify';
import { ROUTER } from '../../../constants/router';

const ModalInactive = ({
    open,
    handelClose,
    handelOk,
    loading,
    width = 135,
    isConfirm = true,
    confirmText = null,
    cancelText = null,
    workflow,
}) => {
    const { t } = useTranslation();
    const { workflowId } = useParams();
    const notify = useNotify();
    const navigate = useNavigate();
    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-8 text-center">
                {ImgInactive}
                <div className="text-[22px] font-normal whitespace-pre-line">
                    {t('You confirm to Inactive Workflow')}
                </div>
                <div className="whitespace-pre-line text-[#65707A] text-[14px] py-2">
                    <span className="font-semibold">
                        {' '}
                        “{workflow?.dsTypeName}”{' '}
                    </span>
                    {t('of domain')}
                    <span className="font-semibold">
                        {' '}
                        {workflow?.domainName}{' '}
                    </span>
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4 my-4">
                {isConfirm ? (
                    <>
                        <Button
                            style={{ width }}
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                        >
                            {cancelText ? cancelText : t('common.Cancel')}
                        </Button>
                        <Button
                            style={{ width }}
                            loading={loading}
                            onClick={async () => {
                                try {
                                    const { data } =
                                        await WorkflowService.workflowInactive(
                                            workflowId
                                        );
                                    if (data?.resultCode === 1) {
                                        handelClose();
                                        navigate(`${ROUTER.DS_360.WORKFLOW}`);
                                    } else {
                                        handelClose();
                                        notify({
                                            type: 'error',
                                            title: t('common.Fail'),
                                            description: t(
                                                'Failed to save data'
                                            ),
                                        });
                                    }
                                } catch (error) {
                                    handelClose();
                                    notify({
                                        type: 'error',
                                        title: t('common.Fail'),
                                        description: t('Failed to save data'),
                                    });
                                }
                            }}
                            size="large"
                            type="primary"
                        >
                            {confirmText ? confirmText : t('common.Confirm')}
                        </Button>
                    </>
                ) : (
                    <Button
                        onClick={handelOk}
                        className="px-6"
                        size="large"
                        type="primary"
                    >
                        {t('common.Close')}
                    </Button>
                )}
            </div>
        </Modal>
    );
};
export default ModalInactive;

const ImgInactive = (
    <svg
        width="220"
        height="120"
        viewBox="0 0 220 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M150.139 110.423H44V110.774H150.139V110.423Z" fill="#7B67FB" />
        <path
            d="M76.9097 23.0903H75.9372L71.8039 38.0837C71.8039 38.0837 71.7229 48.0523 72.6954 52.915C72.6954 52.915 74.3163 50.8078 75.4509 50.8078C76.5856 50.8078 77.6392 40.1909 77.6392 40.1909C77.6392 40.1909 82.0966 25.0354 76.9097 23.0903Z"
            fill="#7B67FB"
        />
        <path
            d="M98.3057 51.7803C98.3057 51.7803 95.7123 59.0743 98.1436 59.5606C100.575 60.0469 101.872 53.8874 101.223 53.077C100.575 52.2665 98.3057 51.7803 98.3057 51.7803Z"
            fill="#FEB8B8"
        />
        <path
            d="M72.4316 50.2735C72.4316 50.2735 73.1607 57.9806 75.57 57.3947C77.9793 56.8088 76.5539 50.6779 75.624 50.217C74.694 49.7561 72.4316 50.2735 72.4316 50.2735Z"
            fill="#FEB8B8"
        />
        <path
            d="M78.6925 95.3826C78.6925 95.3826 79.8271 100.894 77.8821 102.353C75.937 103.811 78.5304 106.891 78.5304 106.891L84.6899 100.407C84.6899 100.407 82.0964 96.3552 82.2585 93.9238L78.6925 95.3826Z"
            fill="#FEB8B8"
        />
        <path
            d="M88.4184 100.408L87.7701 104.784L87.6079 107.864L91.1738 107.54L91.6601 101.218L88.4184 100.408Z"
            fill="#FEB8B8"
        />
        <path
            d="M74.6944 51.0459C74.6944 51.0459 72.6954 51.7804 72.8575 53.8876C73.0196 55.9948 73.5059 62.6405 73.5059 62.6405C73.5059 62.6405 72.047 76.9044 73.5059 81.7671C74.9647 86.6299 77.7202 96.3553 77.7202 96.3553C77.7202 96.3553 81.9346 97.1657 82.9071 94.086C82.9071 94.086 82.745 83.5501 80.962 81.2809C79.179 79.0116 80.4757 78.3632 80.6378 78.0391C80.7999 77.7149 81.2862 77.2286 81.2862 76.7423C81.2862 76.2561 81.4483 74.4731 81.4483 73.8247C81.4483 73.1763 81.2862 73.3384 81.6104 72.3659C81.9346 71.3934 82.2587 71.0692 82.2587 70.9071C82.2587 70.745 85.0143 62.1542 85.0143 62.1542L88.5803 82.0913C88.5803 82.0913 87.7698 101.704 88.094 101.704C88.4182 101.704 91.9842 103.001 93.2809 101.704C93.2809 101.704 96.5227 84.8469 95.8743 83.8743C95.226 82.9018 95.0639 82.7397 95.226 81.7671C95.3881 80.7946 95.7122 80.3083 95.3881 79.8221C95.0639 79.3358 94.5776 77.7149 95.0639 77.2286C95.5501 76.7423 95.7122 74.4731 95.7122 74.4731C95.7122 74.4731 98.4678 58.5882 96.6848 56.3189C94.9018 54.0497 74.6944 51.0459 74.6944 51.0459Z"
            fill="#171717"
        />
        <path
            d="M80.1515 102.515C80.1515 102.515 78.2064 100.083 77.5581 101.218C76.9097 102.353 75.9372 104.136 75.9372 104.136C75.9372 104.136 68.6431 110.457 72.6954 110.619C76.7476 110.781 79.3411 107.864 79.3411 107.864C79.3411 107.864 79.9894 104.622 81.9345 104.622L82.2587 105.432L85.8247 103.163C85.8247 103.163 85.3225 98.8594 83.8716 98.9851L80.1515 102.515Z"
            fill="#171717"
        />
        <path
            d="M86.9593 107.378C86.9593 107.378 91.1736 105.757 91.6599 107.378C92.1462 108.999 92.1462 109.809 92.1462 109.809C92.1462 109.809 95.7122 115.644 92.1462 115.968C88.5802 116.293 86.9593 114.023 86.9593 114.023C86.9593 114.023 87.4456 111.268 86.9593 110.944C86.473 110.619 86.9593 107.378 86.9593 107.378Z"
            fill="#171717"
        />
        <path
            d="M89.8773 17.9035C93.0105 17.9035 95.5504 15.3635 95.5504 12.2303C95.5504 9.09709 93.0105 6.55713 89.8773 6.55713C86.7441 6.55713 84.2041 9.09709 84.2041 12.2303C84.2041 15.3635 86.7441 17.9035 89.8773 17.9035Z"
            fill="#FEB8B8"
        />
        <path
            d="M85.663 13.5273L84.5283 19.8489L92.4708 21.794C92.4708 21.794 90.6067 17.1744 92.6328 15.1483C93.1454 14.6357 85.663 13.5273 85.663 13.5273Z"
            fill="#FEB8B8"
        />
        <path
            d="M85.0113 17.1558C84.8199 17.1918 84.6426 17.2811 84.4997 17.4135C84.3569 17.5458 84.2543 17.7158 84.2037 17.9038C84.0622 18.3695 83.843 18.8079 83.5553 19.2005C83.5553 19.2005 75.9371 22.7665 75.9371 23.2528C75.9371 23.7391 79.0168 34.1129 79.0168 34.1129C79.0168 34.1129 79.1789 40.5965 77.8822 42.0553C76.5855 43.5141 75.2887 48.8631 75.6129 49.3493C75.9371 49.8356 73.3436 50.9702 74.3162 51.7807C75.2887 52.5912 88.9043 60.3715 97.0088 56.8055C97.0088 56.8055 97.1709 55.3467 97.0088 54.3741C96.8468 53.4016 97.9814 50.1598 97.6572 49.0252C97.333 47.8905 97.6572 36.22 97.6572 36.22L99.3277 22.4007C99.3596 22.1383 99.298 21.8729 99.1537 21.6513C99.0094 21.4297 98.7917 21.2661 98.5387 21.1891C96.6705 20.6213 92.3381 18.2966 91.7409 18.7953C90.9676 19.441 86.143 19.0012 85.0113 17.1558Z"
            fill="#7B67FB"
        />
        <path
            d="M97.8196 21.1455L97.8299 21.1414C98.0617 21.0484 98.3179 21.0352 98.558 21.104C98.7982 21.1728 99.0085 21.3196 99.156 21.5212C100.16 22.8956 102.274 25.9848 102.52 27.9533C102.844 30.5468 103.817 37.5166 103.655 38.4892C103.493 39.4617 103.331 39.6238 103.655 40.1101C103.979 40.5963 103.817 40.4343 103.655 40.9205C103.493 41.4068 101.548 54.8603 101.548 54.8603C101.548 54.8603 100.251 51.9427 97.8196 52.9152C97.8196 52.9152 98.1438 50.3218 97.8196 49.5113C97.4954 48.7009 97.1712 48.2146 97.4954 47.5662C97.8196 46.9179 97.4954 40.5963 97.3333 39.948C97.1712 39.2996 97.3333 35.8957 97.3333 35.8957L95.8745 29.25L97.8196 21.1455Z"
            fill="#7B67FB"
        />
        <path
            d="M88.8172 13.1963L89.0088 11.8605C89.0535 11.5491 89.2357 11.1398 89.5386 11.2244C89.7963 11.2965 90.3576 11.517 90.4516 11.4504C90.8036 11.2011 91.3362 11.6371 91.7063 11.4156C91.8614 11.3228 91.9625 11.124 92.1427 11.1107C92.2637 11.1185 92.3776 11.1701 92.4631 11.2559C92.7034 11.4648 92.9865 11.6186 93.2925 11.7064C93.446 11.7482 93.608 11.7482 93.7615 11.7064C93.915 11.6645 94.0546 11.5824 94.1656 11.4684C94.2049 11.4078 94.2578 11.3571 94.3201 11.3204C94.3932 11.2994 94.4712 11.303 94.5421 11.3306L95.4877 11.5881C95.6268 11.0839 95.6553 10.5555 95.5714 10.0392C95.4875 9.52286 95.2931 9.03074 95.0016 8.59646C94.6179 8.07573 94.1528 7.62026 93.6242 7.24758C93.0386 6.80206 92.4342 6.38302 91.8111 5.99045C91.1292 5.55963 90.4059 5.15324 89.6084 5.03213C88.8109 4.91104 87.918 5.12769 87.4164 5.75935C87.1805 5.58859 87.0031 5.34903 86.9087 5.07351C86.8525 5.12468 86.8082 5.18757 86.7789 5.25774C86.7496 5.32792 86.7361 5.40366 86.7393 5.47963C86.7425 5.5556 86.7623 5.62995 86.7974 5.69741C86.8325 5.76488 86.8819 5.82383 86.9423 5.87009L86.1425 5.35938C85.9177 5.59544 86.3569 6.02349 86.1654 6.28727C86.1074 6.35251 86.0331 6.40105 85.9501 6.42785C85.5158 6.5971 85.1178 6.8476 84.7774 7.16593C84.3177 7.62686 84.0681 8.25252 83.8539 8.86721C83.3773 10.2344 83.0309 11.8024 83.708 13.0822C83.7848 13.2273 84.7981 15.622 84.9331 15.7154C85.3894 16.0311 85.0923 15.2671 85.4193 15.7154C85.6757 16.067 85.6277 14.7215 86.0088 15.0168C86.1582 15.1237 86.3354 15.185 86.519 15.1933C86.7025 15.2015 86.8845 15.1564 87.0428 15.0633C87.2008 14.9538 87.1499 14.3453 87.0647 13.7866C87.0484 13.6802 87.0584 13.5714 87.094 13.4697C87.1295 13.3681 87.1894 13.2767 87.2684 13.2036C87.3475 13.1305 87.4433 13.0779 87.5474 13.0504C87.6515 13.023 87.7607 13.0214 87.8656 13.046C88.3402 13.1576 88.8091 13.253 88.8172 13.1963Z"
            fill="#171717"
        />
        <path
            opacity="0.1"
            d="M96.6285 26.1074L98.0624 42.2984C98.0624 42.2984 95.0324 28.7189 96.6285 26.1074Z"
            fill="black"
        />
        <path
            d="M69.9917 82.1597C67.6713 85.4396 67.0584 104.107 66.9218 110.091C66.9183 110.226 66.9148 110.354 66.9131 110.475H61.0396C60.9678 110.347 60.9013 110.221 60.8382 110.091C57.3569 103.219 59.2884 94.9801 59.39 94.5633C59.1256 95.8732 60.3216 99.6698 61.6735 103.347C62.4983 92.0398 69.5504 82.7306 69.9917 82.1597Z"
            fill="#7B67FB"
        />
        <path
            d="M134.832 49.0802C138.605 49.0802 141.664 46.0214 141.664 42.2481C141.664 38.4749 138.605 35.416 134.832 35.416C131.059 35.416 128 38.4749 128 42.2481C128 46.0214 131.059 49.0802 134.832 49.0802Z"
            fill="#95A0A8"
        />
        <path
            d="M164.993 52.4963H134.248C131.53 52.4963 128.924 51.4166 127.002 49.4947C125.08 47.5728 124 44.9662 124 42.2482C124 39.5302 125.08 36.9235 127.002 35.0016C128.924 33.0797 131.53 32 134.248 32H164.993C167.711 32 170.317 33.0797 172.239 35.0016C174.161 36.9235 175.241 39.5302 175.241 42.2482C175.241 44.9662 174.161 47.5728 172.239 49.4947C170.317 51.4166 167.711 52.4963 164.993 52.4963ZM134.248 33.3664C131.893 33.3664 129.633 34.3022 127.968 35.9678C126.302 37.6335 125.366 39.8926 125.366 42.2482C125.366 44.6038 126.302 46.8629 127.968 48.5285C129.633 50.1942 131.893 51.1299 134.248 51.1299H164.993C167.348 51.1299 169.607 50.1942 171.273 48.5285C172.939 46.8629 173.874 44.6038 173.874 42.2482C173.874 39.8926 172.939 37.6335 171.273 35.9678C169.607 34.3022 167.348 33.3664 164.993 33.3664H134.248Z"
            fill="#95A0A8"
        />
        <path
            d="M135.355 86.6906C139.129 86.6906 142.187 83.6317 142.187 79.8585C142.187 76.0852 139.129 73.0264 135.355 73.0264C131.582 73.0264 128.523 76.0852 128.523 79.8585C128.523 83.6317 131.582 86.6906 135.355 86.6906Z"
            fill="#7B67FB"
        />
        <path
            d="M164.993 90.1067H134.248C131.53 90.1067 128.924 89.027 127.002 87.1051C125.08 85.1832 124 82.5765 124 79.8585C124 77.1405 125.08 74.5339 127.002 72.612C128.924 70.6901 131.53 69.6104 134.248 69.6104H164.993C167.711 69.6104 170.317 70.6901 172.239 72.612C174.161 74.5339 175.241 77.1405 175.241 79.8585C175.241 82.5765 174.161 85.1832 172.239 87.1051C170.317 89.027 167.711 90.1067 164.993 90.1067ZM134.248 70.9768C131.893 70.9768 129.633 71.9125 127.968 73.5782C126.302 75.2438 125.366 77.5029 125.366 79.8585C125.366 82.2141 126.302 84.4732 127.968 86.1389C129.633 87.8045 131.893 88.7403 134.248 88.7403H164.993C167.348 88.7403 169.607 87.8045 171.273 86.1389C172.939 84.4732 173.874 82.2141 173.874 79.8585C173.874 77.5029 172.939 75.2438 171.273 73.5782C169.607 71.9125 167.348 70.9768 164.993 70.9768H134.248Z"
            fill="#7B67FB"
        />
    </svg>
);
